import styled from "@emotion/styled/macro";
import { colors } from "../../../../common/styles/theme.styles";

export const VaultTooltipsBarWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    
    @media (max-width: 768px) {
        gap: 12px;
        padding: 12px;
    }
    
    ${({ position }) => position === 'footer' && `
        background: #FFF;
        flex: 1;
        justify-content: flex-end;
    `}
    
    ${({ position }) => position === 'bottom' && `
        margin-top: auto;
        padding: 20px 0;
        
        @media (max-width: 768px) {
            margin-top: 16px;
        }
    `}
`;

export const VaultTooltipButton = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 8px 12px;
    border-radius: 10px;
    background: #E9EAEB;
    cursor: pointer;
    position: relative;
    transition: all 0.2s ease;

    :hover {
        background: ${colors.darkGray1};
    }
    
    @media (max-width: 768px) {
        padding: 6px 10px;
        gap: 4px;
    }
`;

export const VaultTooltipButtonIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;

    ${VaultTooltipButton}:hover & {
        svg {
            path {
                fill: #FFF;
            }
        }
    }
    
    svg {
        width: 16px;
        height: 16px;
        transition: all 0.2s ease;
    }
`;

export const VaultTooltipButtonText = styled.div`
    font-family: Circular;
    font-size: 13px;
    font-weight: 500;
    line-height: 16px;
    color: ${colors.darkGray1};
    transition: color 0.2s ease;

    ${VaultTooltipButton}:hover & {
        color: #FFF;
    }

    @media (max-width: 768px) {
        font-size: 12px;
        line-height: 14px;
    }
`;

export const VaultTooltipSecuredContent = styled.div`
    padding: 16px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 450;
`;

export const VaultTooltipConciergeContent = styled.div`
    padding: 16px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 450;
    
    div {
        margin-bottom: 2px;
        
        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export const VaultTooltipHowItWorksContent = styled.div`
    font-size: 14px;
    line-height: 18px;
    font-weight: 450;
`;

export const VaultTooltipStepRow = styled.div`
    display: flex;
    padding: 16px 0;
    align-items: center;
    gap: 24px;
    align-self: stretch;
    border-top: 1px solid ${colors.darkGray2};
    
    &:first-of-type {
        border-top: none;
    }
`;

export const VaultTooltipStepIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: ${colors.darkGray2};
    flex-shrink: 0;
    
    svg {
        width: 16px;
        height: 16px;
    }
`;

export const VaultTooltipStepDetails = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    flex: 1;
    
    color: ${colors.gray2};
    font-size: 13px;
    font-weight: 450;
    line-height: normal;
`;

export const VaultTooltipStepTitle = styled.div`
    color: #FFF;
    font-size: 16px;
    font-weight: 500;
    line-height: normal;
    margin-bottom: 4px;
`; 